import ButtonMultiClick from "@/components/Buttons/ButtonMultiClick";
import { useDeviceInfoQuery } from "@/hooks";
import config from "@/lib/config";
import maybeIOS from "@/lib/maybeIOS";
import { useCallback } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function OpenApp(_ref) {
  let {
    watch
  } = _ref;
  const {
    data: {
      deviceInfo
    } = {}
  } = useDeviceInfoQuery({
    fetchPolicy: "cache-first"
  });
  const {
    isAndroid
  } = deviceInfo !== null && deviceInfo !== void 0 ? deviceInfo : {};
  const isIOS = maybeIOS(deviceInfo);
  const mobileAppLinkVOD = `spooxnew://works/${watch.episode.id}`;
  const openApp = useCallback(() => {
    if (isIOS) {
      window.location.href = mobileAppLinkVOD;
    } else if (isAndroid) {
      window.location.href = `intent://works/${watch.episode.id}#Intent;scheme=spooxnew;package=${config.androidNewPackageName};end`;
    }
  }, [isAndroid, isIOS, watch, mobileAppLinkVOD]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(ButtonMultiClick, {
      fillColor: true,
      large: true,
      onClick: openApp,
      children: "\u30A2\u30D7\u30EA\u3067\u8996\u8074\u3059\u308B"
    }), isIOS && /*#__PURE__*/_jsx("div", {
      children: "SPOOX NEXT\u30A2\u30D7\u30EA\u306E\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u304C\u307E\u3060\u306E\u65B9\u306F\u30A2\u30D7\u30EA\u30B9\u30C8\u30A2\u3088\u308A\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3092\u304A\u9858\u3044\u3057\u307E\u3059\u3002"
    }), isAndroid && /*#__PURE__*/_jsx("div", {
      children: "SPOOX NEXT\u30A2\u30D7\u30EA\u306E\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u304C\u307E\u3060\u306E\u65B9\u306F\u30A2\u30D7\u30EA\u30B9\u30C8\u30A2\u3088\u308A\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3092\u304A\u9858\u3044\u3057\u307E\u3059\u3002"
    })]
  });
}